/*
 * Project: bellcloud
 * File: packages/types/device/lite/protocol_fn_information.ts
 * Author: SWAN
 * Created: 2025-07-08 11:43:07
 * Description: ClassID.INFORMATION (0x01)에 대한 FunctionID별 파라미터 정의
 */

import type { FunctionParameter } from '../fns';

export const params_information: Record<number, FunctionParameter[]> = {
  0x02: [
    {
      name: 'serial_number',
      type: 'au8[]',
      bytes: 20,
      comment: 'Characters, null termination',
      format: 'string',
    },
    {
      name: 'manufacture_date',
      type: 'u16',
      bytes: 2,
      comment: 'The date of production. Days since 2023.01.01',
      format: 'date_from_basedate',
    },
    {
      name: 'hw_version',
      type: 'au8[]',
      bytes: 2,
      comment: '[0]: PCB, [1]: TBD',
      format: 'version',
    },
    {
      name: 'fw_version',
      type: 'au8[]',
      bytes: 3,
      comment: '[0]: major, [1]: minor, [2]: patch',
      format: 'version',
    },
    {
      name: 'sensor_type',
      type: 'au8[]',
      bytes: 5,
      comment: 'See below equipped sensor (0~15)',
      format: 'enum_array_sensors',
    },
    {
      name: 'calibration_due_date',
      type: 'as16[]',
      bytes: 10,
      comment: '0~365 days left, if negative value is arrived, it is overdue',
      format: 'array_date_with_sign',
    },
    {
      name: 'bump_due_date',
      type: 'as16[]',
      bytes: 10,
      comment: '0~365 days left, if negative value is arrived, it is overdue',
      format: 'array_date_with_sign',
    },
    {
      name: 'last_span_calibration_days',
      type: 'au16[]',
      bytes: 10,
      comment: 'Days since 2023.01.01',
      format: 'array_date_from_basedate',
    },
    {
      name: 'last_bump_days',
      type: 'au16[]',
      bytes: 10,
      comment: 'Days since 2023.01.01',
      format: 'array_date_from_basedate',
    },
    {
      name: 'activation_date_time',
      type: 'u16',
      bytes: 2,
      comment: 'Days of activation. At first power-up, will be recorded',
      format: 'date',
    },
    {
      name: 'unit',
      type: 'au8[]',
      bytes: 5,
      comment: 'Gas unit, see below',
      format: 'enum_array_gas_conc_unit',
    },
    {
      name: 'decimal_point',
      type: 'au8[]',
      bytes: 5,
      comment: 'Decimal point, 0~2',
      format: 'array_number',
    },
    {
      name: 'last_zero_calibration_days',
      type: 'au16[]',
      bytes: 10,
      comment: 'Days since 2023.01.01',
      format: 'array_date_from_basedate',
    },
    {
      name: 'min_calibration_due_date',
      type: 's16',
      bytes: 2,
      comment: 'days since 2023.01.01, minimum calibration due including CO2 zero calibration',
      format: 'date_with_sign_from_base_date',
    },
    {
      name: 'min_bump_test_due_date',
      type: 's16',
      bytes: 2,
      comment: 'days since 2023.01.01, minimum bump test due',
      format: 'date_with_sign_from_base_date',
    },
  ],

  0x04: [
    { name: 'mac_address', type: 'au8[]', bytes: 18, comment: 'mac address', format: 'string' },
    {
      name: 'device_name',
      type: 'au8[]',
      bytes: 20,
      comment: 'BELLLITE_ + SN, refer to serial number',
      format: 'string',
    },
    {
      name: 'fw_version',
      type: 'au8[]',
      bytes: 3,
      comment: '[0]: major, [1]: minor, [2]: patch',
      format: 'version',
    },
  ],
};
